'use es6';

import { fromJS } from 'immutable';
import { getQuotaReportingData } from 'reporting-data/customSeries/quota';
import { userInfo as getUserInfo } from 'reporting-data/request/user-info';
export const getQuotas = (requestData, quotaType) => getUserInfo().then(userInfo => {
  const {
    user: {
      scopes
    }
  } = userInfo;
  return getQuotaReportingData(scopes, requestData, quotaType);
}).then(fromJS);